module.exports = __webpack_public_path__ + "img/tips.b2c2de85.png";